import styled, { css } from 'styled-components';
import theme from 'theme/theme';

const Label = styled.label`
  display: block;
  padding: 0 0 5px 0;
  font-size: ${theme.fontSizes.small};
  color: ${theme.colors.dark};
  ${(props) => props.isInline && css`
    padding: 0 5px;
    display: inline-block;
  `}
`;

export default Label;
